import { Component, Input } from '@angular/core';
import { ListLoader } from '../../list-loader/list-loader';
import { FormsModule } from '@angular/forms';
import { MetaDisablerDirective } from '../../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-functionbar-searchresult-buttons[listLoader]',
  templateUrl: './functionbar-searchresult-buttons.component.html',
  imports: [FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class FunctionbarSearchresultButtonsComponent {
  @Input()
  listLoader: ListLoader<any>;

  constructor() {}
}
